import store from "@/store";

export default function bsHelper(barcode) {
	if (store.state.settings.useMagneticScanner) {
		if (barcode.length > 16 && barcode.includes(';')) {
			return barcode.split(';')[1].slice(0, 16)
		}

		return barcode;
	}

	return ''
}
